import { useProductImages } from '../hooks/useProductImages';

type CarouselContainerProps = { children: React.ReactNode };

const CarouselContainer = ({ children }: CarouselContainerProps) => {
	const { blockClass } = useProductImages();

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-carouselContainer--${blockClass}`;
	};

	return (
		<div
			className={`carouselContainer carouselContainer--${blockClass} vtex-store-components-3-x-carouselContainer ${renderClass()} relative overflow-hidden w-100 flex-ns justify-end-ns`}
		>
			{children}
		</div>
	);
};

export default CarouselContainer;
